(function () {
  function tpCounter(el) {
    if (!el) return;
    if (el.getAttribute('data-tp-counter-animated') === 'true') return;

    var target = parseInt(el.getAttribute('data-target'), 10);
    if (isNaN(target)) return;

    el.setAttribute('data-tp-counter-animated', 'true');

    var duration = 2000;
    var startTime = null;
    el.textContent = '0';

    function tick(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var value = Math.floor(progress * target);
      el.textContent = value;
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = target;
      }
    }

    requestAnimationFrame(tick);
  }

  function initCounters(scope) {
    var root = scope || document;
    var items = root.querySelectorAll('[data-tp-counter][data-target]');
    if (!items.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tpCounter(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { root: null, rootMargin: '0px', threshold: 0.2 });

      items.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      items.forEach(function (item) {
        tpCounter(item);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCounters();
    });
  } else {
    initCounters();
  }
})();
